import React from 'react';

export default () => {
  return (
    <div className='orbit-spinner'>
      <div className='orbit'></div>
      <div className='orbit'></div>
      <div className='orbit'></div>
    </div>
  );
};
